export default __webpack_public_path__ + "static/media/Right-BlackChevron.d73c9327.svg";